<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div v-text="'Edit Link'" />
    <div class="modal-body">
      <div>
        <label
          for="edit_link_title"
          v-text="'Title'"
        />
        <input
          id="edit_link_title"
          v-model="form.title"
          type="text"
          name="edit_link_title"
          class="input"
          :class="{ error: hasError('title') }"
          placeholder="Title"
        >
        <span
          v-if="hasError('title')"
          class="help-block"
          v-text="'This field is required!'"
        />
        <label
          for="edit_link_url"
          v-text="'Url'"
        />
        <input
          id="edit_link_url"
          v-model="form.url"
          required
          type="text"
          name="edit_link_url"
          class="input"
          :class="{ error: hasError('url') }"
          placeholder="http://example.org"
        >
        <span
          v-if="hasError('url')"
          class="help-block"
          v-text="'This field is required!'"
        />
        <div class="flex">
          <div class="w-1/2 pr-4">
            <label
              for="create_link_category"
              v-text="'Resource Category'"
            />
            <select
              id="create_link_category"
              v-model="form.category"
              name="create_link_category"
              :class="{ error: hasError('category') }"
            >
              <template v-if="categories.length">
                <option
                  v-for="category in categories"
                  :key="category.id"
                  :value="category.attributes.slug"
                  v-text="category.attributes.title"
                />
              </template>
            </select>
            <span
              v-if="hasError('category')"
              class="help-block"
              v-text="'This field is required!'"
            />
          </div>
          <div class="w-1/2 pl-4">
            <label
              for="resource_icon"
              v-text="'Resource Icon'"
            />
            <ResourceIconSelector
              id="resource_icon"
              v-model="form.icon"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer text-center mt-4">
      <button
        type="button"
        class="btn btn-blue"
        @click="save"
        v-text="'Save'"
      />
      <a
        href="#"
        class="ml-4"
        @click="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
import ResourceIconSelector from 'Resource/Resources/assets/js/components/ResourceIconSelector'

export default {
  name: 'EditLinkModal',
  components: {
    ResourceIconSelector,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      form: {
        title: '',
        url: '',
        category: '',
        icon: '',
      },
      errors: {},
    }
  },
  computed: {
    categories() {
      return this.$store.state.resource.categories
    },
    link() {
      return this.$store.state.resource.editLinkModal.link
    },
  },
  watch: {
    link() {
      this.form.title = this.link?.attributes?.title
      this.form.url = this.link?.attributes?.url
      this.form.category = this.link?.category?.attributes?.slug
      this.form.icon = this.link?.attributes?.icon || ''
    },
  },
  async mounted() {
    await this.$nextTick()

    this.$store.dispatch('resourceGetCategories')
  },
  methods: {
    save() {
      this.$api.active().put(`links/${this.link.uuid}`, {
        title: this.form.title,
        url: this.form.url,
        category: this.form.category,
        icon: this.form.icon,
      }).then(() => {
        this.$emit('updated')

        this.$store.commit('baseAddNotification', {
          type: 'success',
          title: 'Success',
          text: 'Link updated!',
        })

        this.close()
      }).catch((error) => {
        this.$store.commit('baseAddNotification', {
          type: 'error',
          title: 'Error',
          text: error.response.data.message,
        })

        this.errors = error.response.data.errors
      })
    },
    close() {
      this.form.title = ''
      this.form.url = ''
      this.form.category = ''
      this.form.icon = ''
      this.errors = {}

      this.$store.commit('resourceCloseEditLinkModal')
    },
    hasError(field) {
      return this.errors.hasOwnProperty(field)
    },
  },
}
</script>
